import React, { useMemo } from 'react';

import { AnalyticsContext } from '@atlaskit/analytics-next';
import FeatureGates from '@atlaskit/feature-gate-js-client';

import { useOnDismissDialog } from '../../../analytics/use-on-dismiss-dialog';
import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { getHamsKey } from '../../../services/product-to-hams-key';
import { ExperimentCohortControlVariation } from '../../../types';
import { PopupEntryPoint } from '../shared/popup-entry-point';

import { AutoOpenPopupTrigger } from './AutoOpenPopupTrigger';
import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint, EntryPointParams } from './entrypoint';

export function ReverseTrialPopupDialog() {
	const { product, cloudId, shouldAutoOpen, onAutoOpen } = useEditionAwareness();

	const entryPointParams: EntryPointParams = useMemo(
		() => ({
			cloudId,
			hamsProductKey: getHamsKey(product),
		}),
		[cloudId, product],
	);

	if (shouldAutoOpen) {
		// Clears local storage key regardless of experiment cohort
		onAutoOpen?.();
	}
	// Auto-opens popup if on control
	const shouldAutoOpenPopup =
		shouldAutoOpen &&
		FeatureGates.getExperimentValue<ExperimentCohortControlVariation>(
			'jsw_ea_popover_open_vs_close',
			'cohort',
			'control',
		) !== 'variation';

	const onClose = useOnDismissDialog({
		...DIALOG_CONFIG,
		attributes: { autoOpened: shouldAutoOpenPopup },
	});

	return (
		<AnalyticsContext data={{ ...DIALOG_CONFIG, autoOpened: shouldAutoOpenPopup }}>
			{shouldAutoOpenPopup ? (
				// Supports the auto-open functionality for the control cohort of the ea popover experiment
				// TEMPORARY and will be removed in the future
				<AutoOpenPopupTrigger
					entryPoint={entryPoint}
					entryPointParams={entryPointParams}
					placement={'bottom-end'}
					onClose={onClose}
				/>
			) : (
				<PopupEntryPoint
					entryPoint={entryPoint}
					entryPointParams={entryPointParams}
					placement={'bottom-end'}
					onClose={onClose}
				/>
			)}
		</AnalyticsContext>
	);
}
